import { Injectable } from '@angular/core';
import { ViewModel } from '@farris/devkit';
import { BefRepository } from '@farris/bef';
import { of, Observable } from 'rxjs';

@Injectable()
export class RemoteSummaryService {
  constructor(private viewModel: ViewModel) { }
  /**
   * æå¡å¨ç«¯åè®¡
   * @param methodName æå¡å¨ç«¯åè®¡èªå®ä¹å¨ä½åç§°
   * @param filters è¿æ»¤æ¡ä»¶
   */
  public summary(methodName: string, filters: any) {
    const repository = this.viewModel.frameContext.repository as BefRepository<any> || null;
    if (repository) {
      const proxy = repository.proxy;
      if (proxy && typeof proxy[methodName] === 'function') {
        return proxy[methodName](filters) as Observable<any>;
      }
    }
    return of(null);
  }
}
